import React from 'react';

export default function Test() {
  return (
    <div>!!!!!!!!!!! !!!!!!!!!!! !!!!!!!!!!!!!</div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Reports/Test.js